<!-- Global Alerts Layout (Error & Success Floating Notifications Container) -->
<div class="position-fixed top-0 end-0 p-3 z-3 d-flex flex-column gap-2" style="max-width: 350px">
    @if (errorMessage()) {
    <div class="alert alert-danger alert-dismissible shadow border-danger border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0 text-danger fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2"><strong>Execution Error:</strong> {{ errorMessage() }}</div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    } @if (successMessage()) {
    <div class="alert alert-success alert-dismissible shadow border-success border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-check-circle-fill flex-shrink-0 text-success fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2">{{ successMessage() }}</div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    }
</div>

<!-- Page Header Card -->
<div class="card border-0 shadow-sm rounded-4 mb-3 bg-body">
    @if (phoneParam()) {
    <div class="p-3 d-flex align-items-center gap-2">
        <button type="button"
            class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
            (click)="goBack()">
            <i class="fa-solid fa-arrow-left font-xs"></i>
            <span>Back</span>
        </button>
    </div>
    }

    @if(!phoneParam()) {
    <div class="card-body p-3">
        <div class="d-flex align-items-end justify-content-between flex-wrap gap-3">

            <!-- Left Side: Inputs Group (Removed flex-grow-1) -->
            <div class="d-flex flex-wrap align-items-center gap-3">

                <!-- Status Filter Dropdown (Fixed width, no flex growing) -->
                <div class="filter-input-field" style="width: 200px;">
                    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
                        Choose LMS Redeem Status
                    </label>
                    <div class="input-group shadow-sm rounded">
                        <span class="input-group-text border bg-body text-body-secondary font-xs">
                            <i class="fa-solid fa-layer-group"></i>
                        </span>
                        <select name="checkType" [(ngModel)]="lmsRedeemStatus"
                            class="form-select form-select-sm text-body font-xs border-start-0 ps-0 font-monospace">
                            @for (option of lmsRedeemStatusOption; track option) {
                            <option [value]="option">{{ option }}</option>
                            }
                        </select>
                    </div>
                </div>

                <!-- Calendar Timeline Start Date Picker (Fixed compact width) -->
                <div class="filter-input-field" style="width: 180px;">
                    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
                        Start Date
                    </label>
                    <div class="input-group shadow-sm rounded">
                        <span class="input-group-text border bg-body text-body-secondary font-xs">
                            <i class="fa-solid fa-calendar-day"></i>
                        </span>
                        <input type="date" [(ngModel)]="startDate" name="startDate"
                            class="form-control form-control-sm text-body font-xs border-start-0 ps-0 font-monospace" />
                    </div>
                </div>

                <!-- Calendar Timeline End Date Picker (Fixed compact width) -->
                <div class="filter-input-field" style="width: 180px;">
                    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
                        End Date
                    </label>
                    <div class="input-group shadow-sm rounded">
                        <span class="input-group-text border bg-body text-body-secondary font-xs">
                            <i class="fa-solid fa-calendar-check"></i>
                        </span>
                        <input type="date" [(ngModel)]="endDate" name="endDate"
                            class="form-control form-control-sm text-body font-xs border-start-0 ps-0 font-monospace" />
                    </div>
                </div>
            </div>

            <!-- Right Side: Unified Action Buttons Container -->
            <div class="d-flex align-items-center flex-wrap gap-2">
                <button type="button"
                    class="btn btn-sm btn-info px-3 py-2 shadow-sm text-body fw-bold d-inline-flex align-items-center gap-1.5 transition-base"
                    (click)="fetchCourseRedeemRecords()">
                    <i class="fa-solid fa-filter font-xs"></i> <span>Check</span>
                </button>
                <button type="button"
                    class="btn btn-sm btn-outline-warning px-3 py-2 shadow-sm fw-semibold d-inline-flex align-items-center gap-1.5 transition-base"
                    (click)="resetForm()">
                    <i class="fa-solid fa-rotate-left font-xs"></i> <span>Clear</span>
                </button>
                <button type="button"
                    class="btn btn-sm btn-outline-success px-3 py-2 shadow-sm fw-semibold d-inline-flex align-items-center gap-1.5 transition-base"
                    data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
                    <i class="bi bi-download font-xs"></i> <span>Download CSV</span>
                </button>
            </div>

        </div>
    </div>
    }
</div>

<!-- Responsive Table Outer Box -->
<div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 transition-base">
        <!-- Table Header Structure -->
        <thead class="table-light border-bottom font-monospace small text-uppercase tracking-wider text-body-secondary">
            <tr>
                <th class="ps-4 py-3">No</th>
                <th class="py-3">Redeem Id</th>
                <th class="py-3">Customer Login Phone</th>
                <th class="py-3">LMS Course Name</th>
                <th class="py-3">Redeemed Date</th>
                <th class="py-3">Redeem status</th>
                <th class="py-3">Coupon Serial Number</th>
                <th class="py-3">Coupon Code</th>
                <th class="py-3">Processed By</th>
                <th class="py-3">Processed Date</th>
            </tr>
        </thead>

        <!-- Table Body Container -->
        <tbody class="small text-body">
            @for (redeem of courseRedeemList() | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems:
            allTotal() }; track redeem.id || $index; let i = $index) {

            <tr class="align-middle transition-base hover-bg-light">

                <td class="ps-4 font-monospace font-xs text-secondary fw-semibold">
                    {{ redeem.srNo }}
                </td>

                <td class="font-monospace text-body-secondary font-xs">
                    {{ redeem.id }}
                </td>

                <td class="text-body fw-medium">
                    {{ redeem.customerLoginPhone }}
                </td>

                <td class="text-body fw-semibold text-wrap" style="max-width: 250px;">
                    {{ redeem.redeemableItemName }}
                </td>

                <td class="text-body-secondary font-xs font-monospace">
                    {{ redeem.redeemedTS | dateFormat }}
                </td>

                <td class="text-body-secondary fw-semibold font-monospace">
                    {{ redeem.redeemableStatus }}
                    @if (shouldRenderAdminRefundButton(redeem)) {
                    <button type="button"
                        class="btn btn-sm btn-icon btn-outline-danger rounded-circle shadow-sm transition-base"
                        title="Refund" [disabled]="isRefundBtnLoading()[i]" (click)="refundRedeem(redeem, i)">
                        @if (isRefundBtnLoading()[i]) {
                        <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                        } @else {
                        <i class="fa-solid fa-ban font-xs text-danger"></i>
                        }
                    </button>
                    }
                </td>

                <td class="font-monospace text-dark fw-medium font-xs">
                    {{ redeem.serialNumber || '—' }}
                </td>

                <td class="font-monospace text-primary fw-bold font-xs tracking-wide">
                    {{ redeem.couponCode || '—' }}
                </td>

                <td class="text-body-secondary font-xs">
                    {{ redeem.processedBy || '—' }}
                </td>

                <td class="text-body-secondary font-xs font-monospace">
                    {{ redeem.processedTS ? (redeem.processedTS | dateFormat) : '—' }}
                </td>
            </tr>

            } @empty {
            <tr>
                <td colspan="10" class="py-5 text-body-secondary">
                    <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                        <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                        <span class="tracking-wider">No Redeems found.</span>
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>

    <div class="card-footer bg-transparent border-top py-2.5">
        <div class="d-flex justify-content-center">
            <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
                class="dashboard-pagination" (pageChange)="handlePageChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
    style="backdrop-filter: blur(4px)">
    <!-- Mini Spinner -->
    <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <!-- Text Badge Layout (Uses your global micro utilities) -->
    <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">Loading...</div>
</div>
}

<div class="modal fade" id="downloadCSVModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4 bg-body">
            <!-- Modal Header -->
            <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 class="modal-title fw-bold text-gradient-primary d-flex align-items-center">
                    <i class="bi bi-file-earmark-arrow-down me-2 fs-4"></i>
                    <span>Download CSV</span>
                </h5>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
                    [disabled]="downloading()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body py-3 px-4">

                <!-- File Name Input -->
                <div class="form-floating mb-3">
                    <input type="text" class="form-control border-2 shadow-none" id="fileNameInput"
                        placeholder="Enter file name" [(ngModel)]="downloadFileName" [disabled]="downloading()" />
                    <label for="fileNameInput" class="text-body-secondary fw-medium">File Name Target</label>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer border-top-0 pt-2 pb-4 px-4">
                <button type="button" class="btn btn-sm btn-light px-3 fw-medium text-body-secondary"
                    data-bs-dismiss="modal" [disabled]="downloading()">
                    Cancel
                </button>

                <button type="button"
                    class="btn btn-sm btn-success text-white px-4 fw-bold shadow-sm d-inline-flex align-items-center gap-1.5 micro-action-btn"
                    (click)="downloadFile()" [disabled]="!downloadFileName() || downloading()">
                    @if (downloading()) {
                    <span class="spinner-border micro-spinner text-white" role="status" aria-hidden="true"></span>
                    <span>Exporting...</span>
                    } @else {
                    <i class="bi bi-download font-xs"></i>
                    <span>Export CSV</span>
                    }
                </button>
            </div>
        </div>
    </div>
</div>